import React, { useEffect, useState } from "react"
import { Container, Row } from "reactstrap"
import { useNavigate, useParams } from "react-router-dom"
import axios from "axios"
import configure from "configure"
import Icons1 from "../../../assets/images/Portflio-icon/icons.png"
import Icons2 from "../../../assets/images/Portflio-icon/icon2.png"
import Icons3 from "../../../assets/images/Portflio-icon/icon3.png"
import Icons4 from "../../../assets/images/Portflio-icon/icon4.png"
import Icons5 from "../../../assets/images/Portflio-icon/icon5.png"
import Icons6 from "../../../assets/images/Portflio-icon/icon6.png"
import image1 from "../../../assets/images/Holiday/AddHoliday.jpg"
import image2 from "../../../assets/images/Holiday/EditHoliday.jpg"
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import Loader from "pages/Separate/Loader"

const ViewCaseStudy = () => {
  const navigate = useNavigate()
  const [mainImg, setmainImg] = useState();
  const [imgViewer, setImgViewer] = useState(false);
  const { id } = useParams()
  const [Data, setData] = useState({})
  const [Loading, setLoading] = useState(false)
  const [parsedResults, setparsedResults] = useState([])
  const [TestimonialImages, setTestimonialImages] = useState([])
  const [images, setImages] = useState([]);
  const [websiteLogo, setWebsiteLogo] = useState([]);

  const icons = [
    Icons1,
    Icons2,
    Icons3,
    Icons4,
    Icons5,
    Icons6,
  ]
  useEffect(() => {
    // setImages([image1, image2, image1, image2, image1])
    // setmainImg(image1)
  }, [])
  useEffect(() => {
    fetchNodeData()
  }, [])

  async function fetchNodeData() {
    setLoading(true)
    axios.get(`${configure.nodeApi}/case-study/${id}`).then(res => {
      setLoading(false)
      setData(res?.data?.caseStudy)
      setparsedResults(JSON.parse(res?.data?.caseStudy?.achieved_results) || [])
      const images = JSON.parse(res?.data?.caseStudy?.project_image || [])
      setImages(images)
      setmainImg(images[0])
      setTestimonialImages(
        JSON.parse(res?.data?.caseStudy?.testimonial_image || "[]")
      )
      setWebsiteLogo(
        JSON.parse(res?.data?.caseStudy?.websiteLogo || [])
      )
    })
  }
  const carouselSettings = {
    dots: false,
    arrows: false,
    infinite: images?.length > 4, // only enable infinite if more than one slide
    autoplay: false,
    autoplaySpeed: 3000,
    speed: 1000,
    fade: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          arrows: false,
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 480,
        settings: {
          arrows: false,
          slidesToShow: 1,
        },
      },
    ],
  };
  const isVideo = (fileName) => fileName.toLowerCase().endsWith(".mp4");
  return (
    <React.Fragment>
      {Loading && <Loader />}
      <div className="page-content mb-3">
        <Container fluid>
          <Row className="bg-white px-2 py-4 shadow mb-3 px-1">
            <Row className="border-bottom">
              <div className="col-md-6 mb-3">
                <h5 className="mb-3">Case Study Information</h5>
              </div>
              <div className="col-md-6 mb-3 text-end">
                <a
                  onClick={e => {
                    navigate(-1)
                  }}
                  className=" btn ms-md-2 btn-red  btn-label "
                >
                  <i className="dripicons-cross me-2 icon-center label-icon"></i>
                  CANCEL
                </a>
              </div>
            </Row>

            <Row className="my-3">
              <h5 className="col-xl-6 mb-0 text-purple">
                Project Name :{" "}
                <span className="">{Data?.project_name}</span>
              </h5>
              <h5 className="col-xl-6 mb-0 text-purple text-end">
                Technolgy :{" "}
                <span className="">{
                  Data?.technologies?.map((obj, i) => (<span className="" key={i}>{obj}, </span>))
                }</span>
              </h5>
            </Row>

            <div className="my-2 pt-2">
              <div className="row align-items-center">
                <div className="col-xxl-8 col-md-7">
                  <div className="main-img">
                    {mainImg && isVideo(mainImg) ? (
                      <video
                        src={`${configure.nodeImgApi}/${mainImg}`}
                        height={400}
                        className="object-fit-cover w-100 caseStudy-img"
                        style={{ objectFit: "cover" }}
                        controls
                        autoPlay
                        muted
                        onContextMenu={(e) => e.preventDefault()}
                      />
                    ) : (
                      <img
                        src={mainImg ? `${configure.nodeImgApi}/${mainImg}` : ""}
                        alt=""
                        onClick={() => setImgViewer(true)}
                        height={400}
                        className="object-fit-cover w-100 caseStudy-img"
                        style={{ objectFit: "cover" }}
                      />
                    )}
                  </div>
                </div>
                <div className="col-xxl-4 col-md-5">
                  <div className=" ">
                    <div className="">
                      <Slider {...carouselSettings}>
                        {/* Slide 1: First 4 items */}
                        <div>
                          <div className="row">
                            {images?.slice(0, 4).map((item, index) => (
                              <div className="col-md-6 mb-4" key={index}>
                                {isVideo(item) ? (
                                  <video
                                    src={`${configure.nodeImgApi}/${item}`}
                                    className="w-100 h-190 caseStudy-img"
                                    height={180}
                                    onClick={() => setmainImg(item)}
                                    muted
                                    preload="metadata"
                                    style={{ objectFit: "cover", cursor: "pointer" }}
                                  />
                                ) : (
                                  <img
                                    src={`${configure.nodeImgApi}/${item}`}
                                    onClick={() => setmainImg(item)}
                                    alt=""
                                    className="w-100 h-190 caseStudy-img"
                                    height={180}
                                    style={{ objectFit: "cover", cursor: "pointer" }}
                                  />
                                )}
                              </div>
                            ))}
                          </div>
                        </div>

                        {/* Slide 2: Next 4 items (if exist) */}
                        {images?.length > 4 && (
                          <div>
                            <div className="row">
                              {images.slice(4, 8).map((item, index) => (
                                <div className="col-md-6 mb-4" key={index}>
                                  {isVideo(item) ? (
                                    <video
                                      src={`${configure.nodeImgApi}/${item}`}
                                      className="w-100 h-190 caseStudy-img"
                                      height={180}
                                      onClick={() => setmainImg(item)}
                                      muted
                                      preload="metadata"
                                      style={{ objectFit: "cover", cursor: "pointer" }}
                                    />
                                  ) : (
                                    <img
                                      src={`${configure.nodeImgApi}/${item}`}
                                      onClick={() => setmainImg(item)}
                                      alt=""
                                      className="w-100 h-190 caseStudy-img"
                                      height={180}
                                      style={{ objectFit: "cover", cursor: "pointer" }}
                                    />
                                  )}
                                </div>
                              ))}
                            </div>
                          </div>
                        )}
                      </Slider>
                    </div>
                  </div>
                </div>
              </div>

              <div className="row my-5">
                <div className="col-xl-4 pe-4">
                  <h3 className="text-purple fw-bold">{Data?.project_name}</h3>
                  <h5
                    className="lh-base mt-4 mb-3"
                    dangerouslySetInnerHTML={{ __html: Data?.project_overview }}
                  ></h5>
                </div>
                <div className="col-xl-4 pe-5 splitter-left">
                  <h3 className="text-purple fw-bold">Problems</h3>
                  <h5
                    className="lh-base mt-4 mb-3"
                    dangerouslySetInnerHTML={{
                      __html: Data?.problem_information,
                    }}
                  ></h5>
                </div>
                <div className="col-xl-4 d-flex ps-0 flex-column align-items-center splitter-left">
                  <img
                    src={`${configure?.nodeImgApi}/${websiteLogo[0]}`}
                    style={{ height: "100px", width: "100px", objectFit: "cover" }}
                    className="object-fit-cover mb-3"
                  ></img>
                  <a
                    href={Data?.website}
                    target="__blank"
                    className="text-dark d-flex align-items-center gap-2 fs-5 mb-2"
                  >
                    <h5>Visit Website</h5>
                    <i className="fas fa-long-arrow-alt-right"></i>
                  </a>
                  {Data?.credential_email && Data?.credential_password && (
                    <div className="credential-look">
                      <div className="d-flex mb-2 align-items-center gap-2">
                        <i className="fas fa-envelope"></i>
                        <h5>{Data?.credential_email}</h5>
                      </div>
                      <div className="d-flex align-items-center gap-2">
                        <i className="fas fa-key "></i>
                        <h5 className="mb-0">{Data?.credential_password}</h5>
                      </div>
                    </div>
                  )}
                </div>
              </div>

              <div className=" my-5">
                <h1 className="text-purple fw-bold text-center">
                  Strategy & Approach
                </h1>
                <div className="row mt-4">
                  <div className="col-xl-12">
                    <h5
                      className="lh-base mt-4 mb-3"
                      dangerouslySetInnerHTML={{
                        __html: Data?.strategy_and_approach,
                      }}
                    ></h5>
                  </div>
                </div>
              </div>
              <div className="my-5">
                <h1 className="text-purple fw-bold text-center">
                  Achieved Results
                </h1>
                <div className="row mt-4 text-center">
                  {parsedResults?.map((result, index) => {
                    const Icon = icons[index % icons?.length]
                    return (
                      <div key={index} className="col-xl-4 py-4">
                        <img src={Icon} alt="Icons" />
                        <h5>{result}</h5>
                      </div>
                    )
                  })}
                </div>
              </div>

              {TestimonialImages?.[0] && Data?.testimonial?.trim() != "" ? (
                <div className="row my-5 align-items-center">
                  <div className="col-xl-3 d-flex justify-content-center">
                    {TestimonialImages?.[0] &&
                      (/\.(mp4|webm|ogg)$/i.test(TestimonialImages[0]) ? (
                        <video
                          controls
                          className="w-75 object-fit-cover"
                          src={`${configure.nodeImgApi
                            }/${TestimonialImages[0]?.replace(/\\/g, "/")}`}
                        />
                      ) : (
                        <div className="bd-testimonial-four-img">
                          <img
                            className="w-100 object-fit-cover caseStudy-img"
                            src={`${configure.nodeImgApi
                              }/${TestimonialImages[0]?.replace(/\\/g, "/")}`}
                            alt="testimonial"
                            height={150}
                            style={{ objectFit: "cover" }}
                          />
                        </div>
                      ))}
                  </div>
                  <div className="col-xl-8 mt-4 mb-3">
                    <i
                      className="fas fa-quote-right"
                      style={{ fontSize: "30px", color: "#5d0585" }}
                    ></i>
                    <h5
                      className="lh-base mt-3"
                      dangerouslySetInnerHTML={{ __html: Data?.testimonial }}
                    ></h5>
                  </div>
                </div>
              ) : null}
            </div>
          </Row>
        </Container>
      </div>
      <section
        className={`image-viewer ${imgViewer ? "showViewer" : ""
          } d-flex align-items-center`}
      >
        <div className=" row justify-content-center py-5 w-100">
          <div className="col-md-12 px-0 w-100 ">
            <img src={mainImg != null ? `${configure.nodeImgApi}/${mainImg}` : ''} alt="" height={500} className="caseStudy-img" />
          </div>
        </div>
        <a className="close-btn" onClick={() => setImgViewer(false)}>
          <i className="fa fa-times"></i></a>
      </section>

    </React.Fragment>
  )
}

export default ViewCaseStudy
